// Helpers of loading component

import variables from "styles/util/variables";

export const backdropConfig = {
  opacity: 1,
  color: variables.palette["white"]
};
